/* eslint-disable react/display-name,complexity */
import React, { forwardRef, useState, useContext } from 'react';
import cx from 'classnames';
import { Link as RouterLink } from 'react-router-dom';
import { ThemeContext } from 'styled-components';
import { Button, Stepper, Container, Typography } from '../';
import { getBPHelpers } from '../../utils/breakpoints';
import * as S from './styles';
export var ExplanationStepper = forwardRef(function ExplanationStepper(_a, ref) {
    var heading = _a.heading, doneButtonText = _a.doneButtonText, doneButtonAction = _a.doneButtonAction, doneButtonHref = _a.doneButtonHref, skipButtonAction = _a.skipButtonAction, skipButtonHref = _a.skipButtonHref, slides = _a.slides, className = _a.className, style = _a.style;
    var _b = useState(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var themeContext = useContext(ThemeContext);
    var BPHelpers = getBPHelpers(themeContext.breakpoints);
    var screens = BPHelpers.useScreens();
    var rootClass = cx(className);
    var isActiveLastItem = activeIndex === slides.length - 1;
    var nextButtonText = isActiveLastItem ? doneButtonText : 'Next';
    var nextButtonClickHandler = isActiveLastItem ? doneButtonAction : function () { return setActiveIndex(activeIndex + 1); };
    var skipButtonClickHandler = skipButtonAction || doneButtonAction;
    var skipButtonHrefCombined = skipButtonHref || doneButtonHref;
    var buttonColor = isActiveLastItem ? undefined : 'light-grey';
    return (React.createElement(S.Wrapper, { flex: true, fullWidth: true, direction: 'column', className: rootClass, style: style, ref: ref },
        React.createElement(Container, { flex: true, justifyContent: 'center', padded: 'small' },
            heading && (React.createElement(Typography, { size: 'small', variant: 'heading' }, heading)),
            !skipButtonAction && skipButtonHrefCombined ? (React.createElement(S.SkipButton, { as: RouterLink, to: skipButtonHrefCombined }, "Skip")) : (React.createElement(S.SkipButton, { onClick: skipButtonClickHandler }, "Skip"))),
        React.createElement(Stepper, { activeIndex: activeIndex, onChangeHandler: setActiveIndex, adaptive: true }, slides.map(function (slide, index) {
            var image = slide.image;
            if (typeof slide.image !== 'string' && slide.image.tablet) {
                image = screens({
                    small: slide.image.mobile
                }, slide.image.tablet);
            }
            return (React.createElement(Stepper.Item, { key: index },
                React.createElement(S.ItemPaper, null,
                    React.createElement(Container, { padded: 'medium', flex: true, direction: 'column', justifyContent: 'center', alignItems: 'center' },
                        React.createElement(S.Image, { style: { backgroundImage: "url('" + image + "')" } }),
                        React.createElement(Typography, { variant: 'heading', font: 'secondary', size: 'xlarge', align: 'center', style: {
                                fontSize: screens({
                                    small: '2rem'
                                }, '3rem')
                            } }, slide.heading),
                        React.createElement(Typography, { align: 'center', size: screens({
                                small: 'medium'
                            }, 'large') }, slide.text)))));
        })),
        React.createElement(Container, { left: 'xlarge', right: 'xlarge', bottom: 'small' }, isActiveLastItem && doneButtonHref ? (React.createElement(Button, { color: buttonColor, as: RouterLink, to: doneButtonHref }, nextButtonText)) : (React.createElement(Button, { color: buttonColor, onClick: nextButtonClickHandler }, nextButtonText)))));
});
ExplanationStepper.defaultProps = {
    doneButtonText: 'Next'
};
ExplanationStepper.displayName = 'ExplanationStepper';
export default ExplanationStepper;
//# sourceMappingURL=ExplanationStepper.js.map